export default __webpack_public_path__ + "static/media/sticker-yo.6459d246.png";